module.exports = __webpack_public_path__ + "static/sec11bg-1a25deb85285a76cacc1e7054171095b.jpg";